/**
 * Whether the CDS Pasajero Frecuente session bootstrap has resolved and confirmed the
 * visitor is anonymous (not a logged-in member). `isBootstrapped` alone is not enough: a
 * non-401 bootstrap failure (network/5xx) also sets it `true` while leaving `isAuthenticated`
 * `false` and populating `error` — that case means "bootstrap failed, unknown", not "confirmed
 * anonymous". Use this before offering or persisting the opt-in so a transient failure doesn't
 * show/send it for an unconfirmed member.
 * @param {object} session - CDS Pasajero Frecuente session state.
 * @param {boolean} session.isBootstrapped
 * @param {boolean} session.isAuthenticated
 * @param {*} session.error
 * @returns {boolean}
 */
export default function isCdsFrequentPassengerBootstrapConfirmedAnonymous({
  isBootstrapped,
  isAuthenticated,
  error,
}) {
  return Boolean(isBootstrapped) && !error && !isAuthenticated;
}
